import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute,
} from "amazon-cognito-identity-js";
import { cognitoConfig } from "./cognitoConfig";

export const userPool = new CognitoUserPool({
  UserPoolId: cognitoConfig.UserPoolId,
  ClientId: cognitoConfig.ClientId,
});

export function signIn(username: string, password: string) {
  return new Promise((resolve, reject) => {
    const authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });

    const userData = {
      Username: username,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        localStorage.setItem("cognitoUser", JSON.stringify({ username }));
        resolve(result);
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
}

export function confirmSignUp(username: any, code: any) {
  // Confirm sign up implementation
}

export function confirmPasswordFunction(
  username: string,
  verificationCode: string,
  newPassword: string
) {
  return new Promise((resolve, reject) => {
    const userData = {
      Username: username,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onSuccess: () => {
        resolve("Password confirmed!");
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
}

export function forgotPasswordRequest(email: string) {
  return new Promise((resolve, reject) => {
    const userData = {
      Username: email,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.forgotPassword({
      onSuccess: (data) => {
        resolve(data);
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
}

export function signOut() {
  // Sign out implementation
}

export function getCurrentUser() {
  // Get current user implementation
}

export function signUp(username: string, password: string, attributes: any) {
  return new Promise((resolve, reject) => {
    const attributeList: CognitoUserAttribute[] = [];
    for (const key in attributes) {
      attributeList.push(
        new CognitoUserAttribute({ Name: key, Value: attributes[key] })
      );
    }
    attributeList.push(
      new CognitoUserAttribute({
        Name: "updated_at",
        Value: Math.floor(Date.now() / 1000).toString(),
      })
    );

    userPool.signUp(username, password, attributeList, [], (err, result) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(result);
    });
  });
}

export function confirmUser(username: string, verificationCode: string) {
  return new Promise((resolve, reject) => {
    const userData = {
      Username: username,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.confirmRegistration(verificationCode, true, (err, result) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(result);
    });
  });
}

export function getUser(): Promise<{ [key: string]: string }> {
  const cognitoUser = userPool.getCurrentUser();

  return new Promise((resolve, reject) => {
    if (!cognitoUser) {
      reject(new Error("No user found"));
      return;
    }

    cognitoUser.getUserAttributes((err, attributes) => {
      if (err) {
        reject(err);
        return;
      }

      const userAttributes: { [key: string]: string } = {};

      attributes!.forEach((attribute) => {
        userAttributes[attribute.Name] = attribute.Value;
      });

      resolve(userAttributes);
    });
  });
}

export function getSession() {
  const cognitoUser = userPool.getCurrentUser();
  return new Promise((resolve, reject) => {
    if (!cognitoUser) {
      reject(new Error("No user found"));
      return;
    }
    cognitoUser.getSession((err: any, session: unknown) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(session);
    });
  });
}

export function updateUserAttributes(attributes: { [key: string]: string }) {
  const cognitoUser = userPool.getCurrentUser();

  return new Promise(async (resolve, reject) => {
    if (!cognitoUser) {
      reject(new Error("No user found"));
      return;
    }

    await new Promise((res) => cognitoUser.getSession(res));

    const attributeList = Object.keys(attributes).map((key) => {
      return new CognitoUserAttribute({
        Name: key,
        Value: attributes[key],
      });
    });

    cognitoUser.updateAttributes(attributeList, (err, result) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(result);
    });
  });
}

export function sendPhoneNumberCode() {
  const cognitoUser = userPool.getCurrentUser();

  return new Promise(async (resolve, reject) => {
    if (!cognitoUser) {
      reject(new Error("No user found"));
      return;
    }

    await new Promise((res) => cognitoUser.getSession(res));

    cognitoUser.getAttributeVerificationCode("phone_number", {
      onSuccess: (result) => {
        resolve(result);
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
}

export function validatePhoneNumberCode(verificationCode: string) {
  const cognitoUser = userPool.getCurrentUser();

  return new Promise(async (resolve, reject) => {
    if (!cognitoUser) {
      reject(new Error("No user found"));
      return;
    }

    await new Promise((res) => cognitoUser.getSession(res));

    cognitoUser.verifyAttribute("phone_number", verificationCode, {
      onSuccess: (result) => {
        resolve(result);
      },
      onFailure: (err) => {
        reject(err);
      },
    });
  });
}
